module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_wrap"
  }, [_c('div', {
    staticClass: "footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(" 联系我们 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  隐私政策 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  服务协议 | ")]), _vm._v("\n\n        ©2021 上海移宇科技有限公司 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7773b796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportFooter.vue
// module id = 719
// module chunks = 1